import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import TenantApplicationsReport from "../../common/ReportTenantApplications";

class ReportTenantApplications extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - Admin Tenant Applications report component.
     */
    render() {

        return(
            <TenantApplicationsReport companyId={this.props.match.params.companyId} />
        )
    };
}

export default injectIntl(ReportTenantApplications);